var map = {
	"./computer1.jpg": "+Zpw",
	"./computer2.jpg": "XD5W",
	"./computer3.jpg": "4Jwv",
	"./computer4.jpg": "1XMC",
	"./computer5.jpg": "lzD9"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/Q+N";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-images ^\.\/computer.*\.jpg$
// module id = /Q+N
// module chunks = 0